import { useEffect, useRef, useState } from "react";
import { payments } from "@square/web-sdk";
import axios from 'axios';
import MainLayout from '../../components/layouts/MainLayout';
import Breadcrumb from '../../components/shared/Breadcrumbs';


const PaymentForm = () => {
  const initialized = useRef(false);
  const backUrl = process.env.REACT_APP_API_URL;
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const cardRef = useRef(null); 

  const breadcrumbs = [
    { label: "Home", path: "/" },
    { label: "投稿FORM / 決済情報入力", path: "/payment" },
  ];

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
  };
  const handleFirstEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handlePaymentTypeChange = (e) => {
    setPaymentType(e.target.value);
  }

  useEffect(() => {
    async function initializePayment() {
      const paymentsInstance = await payments(
        "sandbox-sq0idb-cvJL2aqA8OnXYV2T8IeWFA",
        "L6696GPZ07J78"
      );
      const card = await paymentsInstance.card();
  
      await card.attach('#card-container', {
        fields: {
          postalCode: {
            enabled: false // 郵便番号を無効化
          }
        }
      });
  
      cardRef.current = card;
    }
  
    if (!initialized.current) {
      initializePayment();
      initialized.current = true;
    }
  }, []);

  const handleSubmit = async () => {
    if (!cardRef.current) return;

    const result = await cardRef.current.tokenize();
    const token = localStorage.getItem('token');
  
    axios.post(`${backUrl}/api/save_card/`, {
      nonce: result.token,
      first_name: firstName,
      email: email,
      type: 'sharehouse',
      post_id: 37,
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`,
      }
    })
    .then(response => {
      console.log("カード保存成功:", response.data);
    })
    .catch(error => {
      console.error("カード保存エラー:", error);
    });
  };

  return (
    <MainLayout>
      <Breadcrumb items={breadcrumbs} />
      <div className="payment__text">
        <h2>投稿が完了いたしました。</h2>
        <h3>お支払いお手続きへ進みます</h3>
        <p>必要情報を入力し登録するボタンを押してください</p>
      </div>
      <div>
      <div className="payment__form-radio">
        <label className="payment__form-radio-label">期間を選択してください</label>
        <div className="payment__form-radio-group">
          <label className="payment__form-radio-input">
            <input
              type="radio"
              name="paymentType"
              value="1"
              checked={paymentType === '1'}
              onChange={handlePaymentTypeChange}
            />
            １週間 / $00
          </label>
          <label className="payment__form-radio-input">
            <input
              type="radio"
              name="paymentType"
              value="2"
              checked={paymentType === '2'}
              onChange={handlePaymentTypeChange}
            />
            ２週間 / $00
          </label>
          <label className="payment__form-radio-input">
            <input
              type="radio"
              name="paymentType"
              value="3"
              checked={paymentType === '3'}
              onChange={handlePaymentTypeChange}
            />
            ３週間 / $00
          </label>
          <label className="payment__form-radio-input">
            <input
              type="radio"
              name="paymentType"
              value="4"
              checked={paymentType === '4'}
              onChange={handlePaymentTypeChange}
            />
            ４週間 / $00
          </label>
        </div>
      </div>
      <div className="payment__form-wrrap">
        <div id="card-container"></div>
        <div className="payment__form-input">
          <input
            type="text"
            value={firstName}
            onChange={handleFirstNameChange}
            placeholder="Name"
          />
        </div>
        <div className="payment__form-input">
          <input
            type="text"
            value={email}
            onChange={handleFirstEmailChange}
            placeholder="Email Address"
          />
        </div>
      </div>
      <button className='payment__form-submit' onClick={handleSubmit}>登録する</button>
    </div>
    </MainLayout>
  );
};

export default PaymentForm;
